<div class="container">
    <div class="header">
        <h5 class="title" data-cy="ops-settings-accounts-modal-header">
            {{ (isEditing ? 'account-setting.edit.dialog.title' : 'account-setting.create.dialog.title') | translate }}
        </h5>
    </div>
    <div class="content">
        <div class="input-container">
            <span class="input-title" data-cy="ops-settings-accounts-modal-account-name-section-header">
                {{ 'account-settings.input.name.title' | translate }}
            </span>
            <app-channel-text-input
                [name]="ACCOUNT_NAME_INPUT"
                label="account-settings.input.name.label"
                [value]="name"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.name"
                [maxLength]="32"
                [showInitialError]="isEditing || isDuplicate">
            </app-channel-text-input>
        </div>
        <div class="password-container">
            <span class="input-title" data-cy="ops-settings-accounts-modal-password-section-header">
                {{ 'account-settings.input.password.validation.title' | translate }}
            </span>
            <div class="password-check-container">
                <span class="password-check-title" data-cy="ops-settings-accounts-modal-password-rules-title">
                    {{ 'account-settings.input.password.validation.sub-title' | translate }}
                </span>
                <span
                    class="password-check-description"
                    data-cy="ops-settings-accounts-modal-password-rules-min-char"
                    [class.pass]="checkMinimum">
                    <mat-icon class="icon" [svgIcon]="checkMinimum ? 'check' : 'close'" />
                    {{ 'account-settings.password.check.message.min-character' | translate }}
                </span>
                <span
                    class="password-check-description"
                    data-cy="ops-settings-accounts-modal-password-rules-letter-number-req"
                    [class.pass]="checkLeastLetterAndNumber">
                    <mat-icon class="icon" [svgIcon]="checkLeastLetterAndNumber ? 'check' : 'close'" />
                    {{ 'account-settings.password.check.message.letter-number-required' | translate }}
                </span>
                <span
                    class="password-check-description"
                    data-cy="ops-settings-accounts-modal-password-rules-spec-char-req"
                    [class.pass]="checkLeastSymbols">
                    <mat-icon class="icon" [svgIcon]="checkLeastSymbols ? 'check' : 'close'" />
                    {{ 'account-settings.password.error.special-char-required' | translate }}
                </span>
            </div>
            <div class="generate-password-container">
                <span class="description" data-cy="ops-settings-accounts-modal-generate-password-description">
                    {{ 'account-settings.input.password.title' | translate }}
                </span>
                <app-button
                    class="generate-password-button"
                    text="account-settings.input.password.generate-button.text"
                    customFontSize="14px"
                    customFontWeight="500"
                    (click)="generatePassword()">
                </app-button>
            </div>
            <div class="generate-password-input-container">
                <app-channel-text-input
                    [name]="PASSWORD_INPUT"
                    label="account-settings.input.password.password.label"
                    type="password"
                    [passwordIconShow]="true"
                    [value]="password"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.password">
                </app-channel-text-input>
                <app-channel-text-input
                    [name]="CONFIRM_PASSWORD_INPUT"
                    label="account-settings.input.password.confirm-password.label"
                    type="password"
                    [passwordIconShow]="true"
                    [value]="confirmPasssword"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.confirmPasssword">
                </app-channel-text-input>
            </div>
        </div>
    </div>
</div>

<div class="buttons-container">
    <div class="cancel button" data-cy="ops-settings-accounts-modal-cancel-button" (click)="cancelClick()">
        {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
    </div>
    <div
        class="create button"
        data-cy="ops-settings-accounts-modal-submit-button"
        [class.disabled]="isCreatingDisabled()"
        (click)="createButtonClick()">
        {{ (isEditing ? 'dlg.save' : 'shipyard.create.dialog.form.button.create') | translate }}
    </div>
</div>
